import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Link2, Plus, FileText, CheckCircle } from "lucide-react";

export default function AttachTestsPanel({
  allTests,
  attachedTests,
  selectedTestIds,
  setSelectedTestIds,
  showDialog,
  setShowDialog,
  onAttach,
}) {
  return (
    <Card className="mb-6" data-testid="attach-tests-panel">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <Link2 className="w-5 h-5 text-primary" />
              Attached Tests
            </CardTitle>
            <CardDescription>Tests candidates must complete for this job</CardDescription>
          </div>
          <Dialog open={showDialog} onOpenChange={setShowDialog}>
            <DialogTrigger asChild>
              <Button className="bg-primary hover:bg-primary/90" data-testid="attach-tests-btn">
                <Plus className="w-4 h-4 mr-2" /> Attach Tests
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-2xl">
              <DialogHeader>
                <DialogTitle>Select Tests to Attach</DialogTitle>
              </DialogHeader>
              <div className="space-y-3 max-h-96 overflow-y-auto">
                {allTests.map((test) => (
                  <label key={test.id} className="flex items-start gap-3 p-3 border rounded-lg hover:bg-gray-50 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedTestIds.includes(test.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedTestIds([...selectedTestIds, test.id]);
                        } else {
                          setSelectedTestIds(selectedTestIds.filter((id) => id !== test.id));
                        }
                      }}
                      className="mt-1"
                      data-testid={`attach-test-checkbox-${test.id}`}
                    />
                    <div className="flex-1">
                      <div className="font-medium">{test.title}</div>
                      <div className="text-sm text-gray-600">
                        {test.category} • {test.question_count} questions
                      </div>
                    </div>
                    {test.is_active && <Badge className="bg-green-100 text-green-800">Active</Badge>}
                  </label>
                ))}
              </div>
              <Button onClick={onAttach} className="w-full" data-testid="attach-tests-confirm-btn">
                Attach Selected Tests
              </Button>
            </DialogContent>
          </Dialog>
        </div>
      </CardHeader>
      <CardContent>
        {attachedTests.length === 0 ? (
          <div className="text-center py-8 text-gray-500">
            <FileText className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>No tests attached yet</p>
          </div>
        ) : (
          <div className="space-y-3">
            {attachedTests.map((test) => (
              <div key={test.id} className="flex items-center justify-between p-4 border rounded-lg bg-white" data-testid={`attached-test-${test.id}`}>
                <div>
                  <h4 className="font-medium">{test.title}</h4>
                  <p className="text-sm text-gray-600">
                    {test.category} • {test.question_count} questions • {test.time_limit_minutes} min
                  </p>
                </div>
                <CheckCircle className="w-5 h-5 text-green-500" />
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
